import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";


import PaginationComponent from "components/common/Pagination/index";
import {
  emptyPaginationObj,
  REPORTING_LIMIT,
  SORT_TYPE,
  getParticipantLabel,
  getLineItemLabel,
} from "Constants/constant";

import { apiPostRequest } from "helpers/Requests";
import { URL_REPORTING_COS_REPORTS } from "store/services/URL";

import { toast } from "react-toastify";

import { addMonths, exportTOExcel, getPlanManagedBy, stripHtmlToPlainText } from "Utils/utils";
import { formatCaseNoteSupportItemFullLabel } from "Utils/caseNoteSupportItem";
import useReportExport from "../useReportExport";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFilterSearchField,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import { withReportSortOnUrl } from "../reportExportUtils";

import CaseNotesTable from "./CaseNotesTable";
import moment from "moment";

const HOURS_TYPE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "billable_hours", label: "Billable" },
  { value: "non_billable_hour", label: "Non-Billable" },
];

const COSReports = ({
  clientsList,
  getClientList,

  supportCoordinator,
  getSupportCoordinatoreList,
  tableDataForReportingLoading,
  settings,
}) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const participantNameLabel = getParticipantLabel(settings?.care_sector, false) + " Name";
  const lineItemLabel = getLineItemLabel(settings?.care_sector);

  useEffect(() => {
    getClientList();
    getSupportCoordinatoreList();
  }, []);

  const [search, setSearch] = useState(null);

  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [workerList, setWorkerList] = useState([]);
  const [participantList, setParticipant] = useState([]);

  useEffect(() => {
    const updateLists = async () => {
      const workers =
        supportCoordinator?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.uuid,
        })) || [];

      const sortedWorkers = workers.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setWorkerList([{ label: "All", value: "all" }, ...sortedWorkers]);

      const participants =
        clientsList?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.uuid,
        })) || [];

      const sortedParticipants = participants.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setParticipant([{ label: "All", value: "all" }, ...sortedParticipants]);
    };

    updateLists();
  }, [clientsList, supportCoordinator]);

  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "cos_case_report",
    "COS Case Note Report",
    { sortBy, sortDescending }
  );
  const [selectedClient, setSelectedClient] = useState(null);
  const [serviceContract, setserviceContract] = useState(null);
  const [hoursType, setHoursType] = useState(HOURS_TYPE_OPTIONS[0]);

  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [isDisableSearch, setIsDisableSearch] = useState(false);

  useEffect(() => {
    if (!isInitialRender) {
      fetchListReports(false, null, {
        page,
        sort_field: sortBy,
        sort_order: sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
      });
    }
  }, [page]);

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = {}
  ) => {
    if (!fromDate && !toDate) {
      toast("Select  date range to get data");
      return;
    }
    const currentPage = filters?.page ?? page;
    setLoader(true);
    let url = `${URL_REPORTING_COS_REPORTS}?per_page=25&page=${currentPage}`;
    url = withReportSortOnUrl(url, filters, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",
      pt_id: isClearAll
        ? "all"
        : selectedClient
        ? selectedClient?.value
        : "all",
      sp_cos_id: isClearAll
        ? "all"
        : serviceContract
        ? serviceContract?.value
        : "all",
      date_range: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
      bill_types: isClearAll ? "all" : hoursType?.value || "all",
    };
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters,
        totalRows: paginationObj?.total,
        setLoader,
        onSyncExcel: exportTOExcelFile,
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          const casenotes = res?.data?.data?.casenotes;
          setPaginationObj((prev) => ({
            ...prev,
            page: casenotes?.current_page ?? currentPage,
            total: casenotes?.total ?? 0,
            totalPages: casenotes?.total_pages ?? Math.ceil((casenotes?.total ?? 0) / (casenotes?.per_page ?? 25)),
          }));
        }
      })
      .catch((error) => {
        console.log({ error });
        setLoader(false);
      });
  };
  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());
  };

  const exportTOExcelFile = (reportData) => {
    let transformedData = null;

    const casenotesList = Array.isArray(reportData?.casenotes) ? reportData.casenotes : reportData?.casenotes?.data ?? [];
    transformedData =
      reportData &&
      casenotesList?.length > 0 &&
      casenotesList?.map((item) => {
        const supportExportLabel =
          item?.support_item_label ??
          formatCaseNoteSupportItemFullLabel(
            item?.support_item_number,
            item?.support_item_name,
            item?.claim_type
          );
        return {
          Participant: `${item?.participant?.first_name} ${item?.participant?.last_name}`,
          Funding_Contract_ID: item?.funding_contract_id ?? "N/A",
          Delivery_Serial_No: item?.delivered_service_number || "N/A",
          Support_Item_Name: supportExportLabel || "N/A",
          Created_By: item?.created_by || "N/A",
          Created_Date: item?.created_at
            ? moment(item?.created_at).format("DD/MM/YYYY")
            : "N/A",
          Managment_Style: item?.manged_by
            ? getPlanManagedBy(item?.manged_by)
            : "N/A",
          Delivered_Date: item?.delivered_date
            ? moment(item?.delivered_date).format("DD/MM/YYYY")
            : "N/A",
          Hours: (item?.hours || item?.mints) ? `${item?.hours ?? '00'}:${item?.mints ?? '00'}` : 'N/A',
          Bill_Type:
            item?.bill_types === "Billable" ||
            item?.bill_types === "billable_hours" ||
            item?.bill_types === "true"
              ? "Billable"
              : "Non-Billable",
          Rate: `${item?.original_rate}$` || "N/A",
          Total_Delivered_Amount: `${item?.total_amount}$` || "N/A",
          Status: item?.status || "N/A",
          Notes: item?.notes && item?.notes !== "null"
            ? stripHtmlToPlainText(item.notes) || "N/A"
            : "N/A",
        };
      });

    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };
  const handleSearch = () => {
    setPage(1);

    const updatedPaginationObj = { ...paginationObj, page: 1 };
    setPaginationObj(updatedPaginationObj);

    fetchListReports(false, null, {
      page: 1,
      sort_field: sortBy,
      sort_order: sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  const handleClearFilters = () => {
    setSearch(null);
    setReports([]);
    setFromDate(null);
    setToDate(null);
    setSelectedClient(null);
    setserviceContract(null);
    setSelectedFromDate(null);
    setHoursType(HOURS_TYPE_OPTIONS[0]);
  };
  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='COS Case Note Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.COS_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label='Participant'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    isDisabled={tableDataForReportingLoading}
                    name='pt_id'
                    isSearch={true}
                    data={participantList || []}
                    selectedOption={selectedClient}
                    handleChange={(e) => setSelectedClient(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Support Coordinators'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    isDisabled={tableDataForReportingLoading}
                    name='contact_type_id'
                    isSearch={true}
                    data={workerList || []}
                    handleChange={(e) => setserviceContract(e)}
                    selectedOption={serviceContract}
                  />
                </ReportFilterField>
                <ReportFilterField label='Hours Type'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    isDisabled={tableDataForReportingLoading}
                    name='bill_types'
                    isSearch={false}
                    data={HOURS_TYPE_OPTIONS}
                    selectedOption={hoursType}
                    handleChange={(e) => setHoursType(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Create Date Range (Max 3 months)' required>
                  <DateRangePickerNew
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                      setReports([]);
                    }}
                    handleChange={(obj) => {
                      if (obj) {
                        obj.fromDate && setFromDate(obj.fromDate);
                        obj.toDate && setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={addMonths(selectedFromDate, 3)}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
                <ReportFilterSearchField
                  label='Search by participant name'
                  search={search}
                  setSearch={setSearch}
                  onSearch={handleSearch}
                  placeholder='Search by participant name'
                />
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loader}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
                <CaseNotesTable
                  flipSort={flipSort}
                  sortDescending={sortDescending}
                  sortBy={sortBy}
                  loader={loader}
                  reportList={reportList}
                  participantNameLabel={participantNameLabel}
                  lineItemLabel={lineItemLabel}
                />
            </ReportTableSection>

              {reportList?.casenotes?.data?.length > 0 && paginationObj?.total > 0 && (
                <div className='bg-white sm:px-6 lg:px-8 w-full py-4 sm:py-6 border-t border-gray-200'>
                  <PaginationComponent
                    page={paginationObj?.page || 1}
                    activeListLength={reportList?.casenotes?.data || []}
                    limit={REPORTING_LIMIT}
                    totalList={paginationObj?.total}
                    handlePagination={(e) => {
                      setPage(e);
                      setPaginationObj((prev) => ({ ...prev, page: e }));
                      fetchListReports(false, null, {
                        page: e,
                        sort_field: sortBy,
                        sort_order: sortDescending
                          ? SORT_TYPE.DESC
                          : SORT_TYPE.ASC,
                      });
                    }}
                    totalPages={paginationObj?.totalPages}
                  />
                </div>
              )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default COSReports;
